var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCollapseIconNew = function SvgCollapseIconNew(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.068 10.705",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".collapse_icon_new_svg__a{fill:#414a5f}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.285 1.654 3.426 3.43a.366.366 0 0 1 0 .538L.281 9.073a.935.935 0 0 0 0 1.346.935.935 0 0 0 1.346 0l4.398-4.394a.935.935 0 0 0 0-1.346L1.653.286a.935.935 0 0 0-1.346 0h.004a.98.98 0 0 0-.022 1.368Z",
    className: "collapse_icon_new_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.042 1.654 3.426 3.43a.366.366 0 0 1 0 .538l-3.43 3.451a.935.935 0 0 0 0 1.346.935.935 0 0 0 1.346 0l4.398-4.394a.935.935 0 0 0 0-1.346L7.41.286a.935.935 0 0 0-1.346 0h.004a.98.98 0 0 0-.022 1.368Z",
    className: "collapse_icon_new_svg__a"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCollapseIconNew);
export default ForwardRef;